import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appModalFocus]'
})
export class ModalFocusDirective {
  KEYCODE_TAB = 9;

  constructor(
    private readonly hostElement: ElementRef
  ) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    if (e.key === 'Tab') {
      const focusableEls = this.hostElement.nativeElement;
      const modalContent = focusableEls.querySelectorAll('a, button, [tabindex]');
      const firstFocusableEl = modalContent[0];
      const lastFocusableEl = modalContent[modalContent.length - 1];
      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    }
  }
}
